import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const FormNetlify = (props) => (
  <form
    {...props}
    className={styles.container}
    name={props.name}
    method="post"
    action="/"
    data-netlify="true"
    data-netlify-honeypot="bot-field"
    onSubmit={(e) => {
      e.preventDefault();
    }}
  >
    <input name="bot-field" hidden />
    {props.children}
  </form>
);

FormNetlify.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormNetlify;
